import React, { Fragment } from "react";
import { Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import ContentCard from "../../../components/Content/ContentCard/index";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SECTION_TITLE_MAIN,
  SECTION_TITLE_AFTER_INDEX,
  SUPPORT_DATA,
} from "./Support.constants";
import { RootBox, SectionTitleTypography } from "./Support.styles";

const Support = () => {
  const { setSelectedTab } = useQuickLinksItems();

  const handleCardClick = (item) => () => {
    if (item.redirect) {
      setSelectedTab(item.tab);
    } else if (item.link) {
      window.open(item.link, "_blank");
    }
  };

  const getCardHeight = (item) =>
    item?.linkBox ? "250px" : item?.height || "150px";

  return (
    <RootBox>
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <Grid2 container spacing={2} sx={{ mt: 4 }}>
        <Grid2 item size={{ xs: 12 }}>
          <SectionTitleTypography>{SECTION_TITLE_MAIN}</SectionTitleTypography>
        </Grid2>

        {SUPPORT_DATA.map((item, index) => (
          <Fragment key={item.id}>
            <Grid2 item size={{ xs: 12, md: item.size ?? 4 }}>
              <ContentCard
                item={item}
                height={getCardHeight(item)}
                clickable={Boolean(item.link || item.redirect)}
                onClick={handleCardClick(item)}
              />
            </Grid2>

            {SECTION_TITLE_AFTER_INDEX[index] && (
              <Grid2 item size={{ xs: 12 }}>
                <SectionTitleTypography>
                  {SECTION_TITLE_AFTER_INDEX[index]}
                </SectionTitleTypography>
              </Grid2>
            )}
          </Fragment>
        ))}
      </Grid2>
    </RootBox>
  );
};

export default Support;
